import React from 'react';
import * as S from './styles';
import { POSTS_PER_PAGE } from '../../constants';

export const Pagination = ({ content, page, onChange }) => {
  const count = Math.ceil(content.length / POSTS_PER_PAGE);

  return count > 1 ? (
    <S.Pagination
      count={count}
      page={page}
      color="blue60"
      onChange={onChange}
      data-testid="pagination"
    />
  ) : null;
};
